import DevicesApi from 'client/api/v2/DevicesApi';
import Vue from 'vue';

export const createOsDistributionModule = () => ({
  namespaced: true,
  state: {
    osList: [],
    sum: '',
  },
  actions: {
    fetchDistribution({ commit }) {
      return DevicesApi.fetchOsDistribution()
        .then((response) => {
          commit('SET_STATE', response.data);
        });
    },
    fetchDistributionLastContact({ commit }, days = 7) {
      return DevicesApi.fetchOsDistributionAccordingLastContact(days)
        .then((response) => {
          commit('SET_STATE', response.data);
        });
    },
    resetState({ commit }) {
      commit('RESET_STATE');
    },
  },
  mutations: {
    SET_STATE(state, payload) {
      Vue.set(state, 'osList', payload.osList ? payload.osList : []);
      Vue.set(state, 'sum', payload.sum);
    },

    RESET_STATE(state) {
      Vue.set(state, 'osList', []);
      Vue.set(state, 'sum', 0);
    },
  },
});

export default createOsDistributionModule();
